import { Point } from "pixi.js";
import { MyWalletTab } from "./MyWalletTab";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { NFTItemsFactory } from "../myWalletNFTs/NFTItemsFactory";
import { ScrollNextElement } from "../myWalletNFTs/scrollItems/ScrollNextElement";
import { WalletTabType } from "../WalletTabType";
import { IInventory } from "by/gamefactory/web3/models/IInventory";
import { NFTPiggyClub } from "by/gamefactory/web3/nfts/NFTPiggyClub";
import { NFTScrollItem } from "../myWalletNFTs/scrollItems/NFTScrollItem";
import { DynamicAssets } from "resources/DynamicAssets";
import { AsyncOperationNotification } from "by/gamefactory/cityversetycoon/scenes/common/components/AsyncOperationNotification";

export class PiggyClubTab extends MyWalletTab {
    private readonly myWalletResources: MyWalletResourcePackage;
    private readonly nftItemsFactory: NFTItemsFactory;
    private readonly inventory: IInventory;
    private readonly piggyClubResources: DynamicAssets;
    private readonly asyncOperationNotification: AsyncOperationNotification;

    private piggyClubsNFT: ReadonlyArray<NFTPiggyClub>;
    private piggyClubScrollItems: Array<NFTScrollItem>;
    private nextPiggyClubScrollItem: ScrollNextElement;

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        nftItemsFactory: NFTItemsFactory,
        inventory: IInventory,
        piggyClubResources: DynamicAssets,
        asyncOperationNotification: AsyncOperationNotification
    ) {
        super(true, WalletTabType.PIGGY_CLUB, {
            elementsWidth: 500,
            elementsMargin: 40,
            scrollPosition: new Point(0, 42)
        });
        this.myWalletResources = myWalletResources;
        this.nftItemsFactory = nftItemsFactory;
        this.inventory = inventory;
        this.piggyClubResources = piggyClubResources;
        this.asyncOperationNotification = asyncOperationNotification;
        this.piggyClubsNFT = inventory.piggyClubsNFT;
        this.piggyClubScrollItems = [];
        this.addScrollItems(this.piggyClubsNFT);
    }

    public async updatePiggyClubs(): Promise<void> {
        if (this.piggyClubsNFT !== this.inventory.piggyClubsNFT) {
            const asyncOperations: Array<Promise<any>> = [];

            const piggyClubsToAdd = this.inventory.piggyClubsNFT.filter((newPiggyClub) => this.piggyClubsNFT.findIndex((oldPiggyClub) => newPiggyClub.id === oldPiggyClub.id) === -1);
            for (const piggyClubToAdd of piggyClubsToAdd) {
                this.piggyClubResources.add(piggyClubToAdd.imageURL);
            }
            const piggyClubsToRemove = this.piggyClubsNFT.filter((oldPiggyClub) => this.inventory.piggyClubsNFT.findIndex((newPiggyClub) => newPiggyClub.id === oldPiggyClub.id) === -1);
            if (piggyClubsToAdd.length !== 0 || piggyClubsToRemove.length !== 0) {
                this.scrollBox.reset();
            }
            for (const piggyClubToRemove of piggyClubsToRemove) {
                const scrollItemIndex = this.piggyClubScrollItems.findIndex((item) => item.data.id === piggyClubToRemove.id);
                if (scrollItemIndex !== -1) {
                    asyncOperations.push(this.scrollBox.removeItem(this.piggyClubScrollItems[scrollItemIndex], true));
                    this.piggyClubScrollItems.splice(scrollItemIndex, 1);
                }
                this.piggyClubResources.remove(piggyClubToRemove.imageURL);
            }
            this.piggyClubsNFT = this.inventory.piggyClubsNFT;
            if (this.piggyClubsNFT.length > 0 && this.nextPiggyClubScrollItem != null) {
                this.scrollBox.removeItem(this.nextPiggyClubScrollItem);
                this.nextPiggyClubScrollItem = null;
            }
            asyncOperations.push(this.piggyClubResources.load());
            await this.asyncOperationNotification.autoShowHide(Promise.all(asyncOperations));
            this.addScrollItems(piggyClubsToAdd);
        }
        this.piggyClubsNFT = this.inventory.piggyClubsNFT;
    }

    private addScrollItems(piggyClubs: ReadonlyArray<NFTPiggyClub>): void {
        for (const nft of piggyClubs) {
            const item = this.nftItemsFactory.createItem(nft);
            if (item == null) {
                continue;
            }
            this.scrollBox.addItem(item as NFTScrollItem);
            this.piggyClubScrollItems.push(item as NFTScrollItem);
        }
        if (this.piggyClubsNFT.length === 0 && this.nextPiggyClubScrollItem == null) {
            this.nextPiggyClubScrollItem = new ScrollNextElement(this.myWalletResources, WalletTabType.PIGGY_CLUB)
            this.scrollBox.addItem(this.nextPiggyClubScrollItem);
        }
    }

    public updatePointer(): void {
        return;
    }
}
